import React from 'react'
import { AuthenticationInputPropTypes } from 'utils/prop_types/AuthenticationInput'
import { Input, InputGroupAddon } from 'components/qstrap'
import Icon from 'components/shared/input/Icon'
import ValidationIcon from 'components/shared/input/ValidationIcon'

/* eslint-disable-next-line react/prefer-stateless-function */
export default class TextInput extends React.Component {
  render() {
    const {
      icon,
      type,
      name,
      handleChange,
      defaultValue,
      className,
      valid,
    } = this.props

    return (
      <div className="input-group">
        <div>
          <Icon name={icon} />
          {type === 'tel' &&
            <InputGroupAddon className="icon-bg-transparent icon-tag phone-country-code">
              +62
            </InputGroupAddon>
          }
          <Input
            name={name}
            type={type}
            onChange={handleChange}
            defaultValue={defaultValue}
            className={className}
            onBlur={handleChange}
            autoComplete="false"
          />
        </div>
        <ValidationIcon valid={valid} enabled />
      </div>
    )
  }
}

TextInput.propTypes = AuthenticationInputPropTypes
TextInput.defaultProps = {
  type: 'text',
  validations: [],
  selectOptions: [],
}
